import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Button, Col, Image, Input, Row, Select } from "antd";
import ButtonGroup from "antd/es/button/button-group";
import { Option } from "antd/es/mentions";
import Modal from "antd/es/modal/Modal";
import moment from "moment";

import fileApi from "../../../../apis/File.api";
import nutrientsApi from "../../../../apis/Nutrients.api";
import { setLoading } from "../../../../redux/store/common/commonDuck";

const NutrientsCertifiedNutritionComponent = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  // const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const imageBaseUrl = process.env.REACT_APP_S3_HOST + "/";
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [error, setError] = useState("");
  const [fileList, setFileList] = useState([]);
  const [editState, setEditState] = useState(false);

  const [confirmHistory, setConfirmHistory] = useState({
    id: "",
    target_type: 3,
    confirm: 1,
    confirm_reason: "",
  });

  const [nutrientsData, setNutrientsData] = useState({
    category: "",
    name: "", //영양제명
    brand_name: "",
    brand_type: "",
    is_certify: "", //헬씨팀 인증 여부
    nutrition_facts: "", //분량
    nutrition_facts_unit: "", // 분량 단위
    energy: "", //칼로리(㎉)
    for_person: "", //인분 수
    for_person_unit: "", //인분 단위
    status: 0,
    created_at: "", //생성일
    created_by_name: user.nickname, //생성자
    created_by: user.id,
    updated_at: "", //수정일
    updated_by_name: user.nickname, //수정자
  });
  const contentName = {
    status: "상태",
    name: "영양제명",
    brand_type: "브랜드타입",
    is_certify: "헬씨팀 인증여부",
    nutrition_facts: "분량",
    nutrition_facts_unit: " 분량 단위",
    energy: "칼로리(㎉)",
    for_person: "인분 수",
    for_person_unit: "인분 단위",
  };
  const [nutrientsNutrition, setNutrientsNutrition] = useState({
    target_type: 3,
    total_dietary_fiber: 0, //	식이섬유
    calcium: 0, //	칼슘(mg)
    fe: 0, //	철(mg)
    magnesium: 0, //	마그네슘(mg)
    perfect_virtue: 0, //	인(㎎)
    potassium: 0, //	칼륨(㎎)
    zinc: 0, //	아연(mg)
    copper: 0, //	구리(mg)
    manganese: 0, //	망간(mg)
    selenium: 0, //	셀레늄(㎍)
    molybdenum: 0, //	몰리브덴(㎍)
    iodine: 0, //	요오드(㎍)
    vitamin_a: 0, //	비타민 A(㎍)
    beta_carotene: 0, //	베타카로틴
    vitamin_d: 0, //	비타민 D(μg)
    vitamin_e: 0, //	비타민 E(mg)
    vitamin_k: 0, //	비타민 K(㎍)
    vitamin_b1: 0, //	티아민(비타민 B1)(mg)
    vitamin_b2: 0, //	리보플라빈(비타민 B2)(mg)
    niacin: 0, //	나이아신(비타민 B3)mg NE
    pantothenic_acid: 0, //	판토텐산(비타민 B5)mg
    pyridoxine: 0, //	피리독신(비타민 B6)mg
    biotin: 0, //	비오틴(비타민 B7)
    folic_acid: 0, //	엽산(비타민 B9)μg
    vitamin_b12: 0, //	코발라민(비타민 B12)µg
    vitamin_c: 0, //	비타민 C(mg)
    omega_3_fatty_acids: 0, //	오메가3(mg)
    chrome: 0, //	크롬 ㎍
    guaranteed: 0, //	보장균수(억cfu)
    lutein: 0, //	루테인 mg
    zeaxanthin: 0, //	지아잔틴
    astaxanthin: 0, //	아스타잔틴mg
    silymarin: 0, //	실리마린 mg
    coq10: 0, //	CoQ10 mg
    ginsenoside: 0, //	진세노사이드mg
    flavonoids: 0, //	플라보노이드 mg
    theanine: 0, //	테아닌mg
    collagen: 0, //	콜라겐
    l_arginine: 0, //	L-라이신
    l_lysine: 0, //	L-아르기닌
    inositol: 0, //	이노시톨
    octacosanol: 0, //	옥타코사놀
    hca: 0, //	HCA
    udca: 0, //	UDCA
    γ_oryzanol: 0, //	γ-오리자놀
    glucosamine: 0, //	글루코사민
    betaglucan: 0, //	베타글루칸
    brewersyeast: 0, //	맥주효모
    oroticacidhydrate: 0, //	오로트산수화물
    hyaluronic_acid: 0, //	히알루론산mg
    glutamic_acid: 0, //	폴리감마글루탐산 mg
    msm: 0, //	MSM
    total_anthocyanosides: 0, //	총안토시아노사이드
    alpha_s_1_casein: 0, //	알파에스1카제인
    cultured_cells: 0, //	열처리배양균체 수
    rosabine: 0, //	로사빈
    lauric_acid: 0, //	로르산
    linolenic_acid: 0, //	감마리놀렌산(mg)
    catechins: 0, //	녹차추출물(카테킨)(mg)
    lactulose: 0, //	락추로스(mg)
  });

  const typeItems = [
    { typeType: "type", typeValue: 1, typeText: "영양제브랜드" },
  ];

  const certifyItems = [
    { certifyType: "is_certify", certifyValue: false, certifyText: "미인증" },
    { certifyType: "is_certify", certifyValue: true, certifyText: "인증" },
  ];

  const nutritionFactsUnitItems = [
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "mg",
      nutritionUnitText: "mg",
    },
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "g",
      nutritionUnitText: "g",
    },
    {
      nutritionUnitType: "nutrition_facts_unit",
      nutritionUnitValue: "ml",
      nutritionUnitText: "ml",
    },
  ];

  const forPersonUnitItems = [
    {
      personUnitType: "for_person_unit",
      personUnitValue: "g",
      personUnitText: "g",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "ml",
      personUnitText: "ml",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "듀얼포",
      personUnitText: "듀얼포",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "방울",
      personUnitText: "방울",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "병",
      personUnitText: "병",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "분사",
      personUnitText: "분사",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "정",
      personUnitText: "정",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "정제",
      personUnitText: "정제",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "캡슐",
      personUnitText: "캡슐",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "포",
      personUnitText: "포",
    },
    {
      personUnitType: "for_person_unit",
      personUnitValue: "회",
      personUnitText: "회",
    },
  ];

  const statusItems = [
    { statusType: "status", statusValue: 0, statusText: "신청" },
    { statusType: "status", statusValue: 1, statusText: "추가" },
  ];

  const getNutrientsData = async () => {
    setIsLoading(true);
    try {
      const res = await nutrientsApi.readNutrientsNutrition(
        props.match.params.id,
      );
      if (res.code === 200) {
        setIsLoading(false);
        if (res.result.nutrients !== null) {
          setNutrientsData(res.result.nutrients);
        }
        if (res.result.nutrients_nutrient !== null) {
          setNutrientsNutrition(res.result.nutrients_nutrient);
        }
        if (res.result.confirmHistory !== null) {
          setConfirmHistory(res.result.confirmHistory);
        }
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      // setError(error);
    }
  };

  const removeNutrientsData = async () => {
    setIsLoading(true); // 추가설정해야함. 팀장님거 참고하기.
    try {
      // setError("");
      const res = await nutrientsApi.removeNutrients(props.match.params.id);
      if (res.code === 200) {
        setIsLoading(false);
        alert("영양제정보삭제가 완료되었습니다.");
        history.go(-1);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      // setError(error);
    }
  };

  const getImageFile = async () => {
    setIsLoading(true);
    try {
      // setError("");
      const res = await fileApi.readFile(props.match.params.id, 3);
      if (res.code === 200) {
        setIsLoading(false);
        setFileList(res.result.fileList);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      // setError(error);
    }
  };

  useEffect(() => {
    getNutrientsData();
  }, []);

  useEffect(() => {
    if (nutrientsData.status === 0) {
      getImageFile();
    }
  }, [nutrientsNutrition]);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    removeNutrientsData();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleClickEdit = (e) => {
    setEditState(true);
  };

  const handleClickCancel = () => {
    setEditState(false);
  };

  const handleClickComplete = async () => {
    setIsLoading(true);
    for (let i = 0; i < Object.keys(contentName)?.length; i++) {
      if (nutrientsData[Object.keys(contentName)[i]] === "") {
        return alert(Object.values(contentName)[i] + "을(를) 입력해주세요.");
      }
    }
    setNutrientsData({ ...nutrientsData, updated_by: user.id });
    try {
      // setError("");
      const newEditNutrients = {
        nutrients: nutrientsData,
        nutrients_nutrient: nutrientsNutrition,
        confirmHistory: confirmHistory,
      };
      const res = await nutrientsApi.editNutrients(newEditNutrients);
      if (res.code === 200) {
        setEditState(false);
        setIsLoading(false);
        window.alert("영양제정보수정 완료되었습니다.");
        getNutrientsData();
      } else if (res.code === 418) {
        setIsLoading(false);
        let duplication = "";
        for (let i = 0; i < res.result?.length; i++) {
          duplication += `${res.result[i].name}, `;
        }
        window.alert(`중복된 음식정보가 있습니다. \n [${duplication}]`);
      } else {
        setEditState(false);
        setIsLoading(false);
        window.alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      // setError(error);
      setEditState(false);
    }
  };

  const onChange = (e) => {
    if (e.target.name === "nutrients") {
      setNutrientsData({ ...nutrientsData, [e.target.id]: e.target.value });
    } else if (e.target.name === "nutrientsNutrition") {
      setNutrientsNutrition({
        ...nutrientsNutrition,
        [e.target.id]: e.target.value,
      });
    } else {
      console.log("onChange Error", e.target.name);
    }
  };

  const onSelectChange = (value, e) => {
    setNutrientsData({ ...nutrientsData, [e.id]: value });
  };

  const handleClickMenu = (e) => {
    history.go(-1);
  };

  return (
    <div style={{ height: "auto" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <ButtonGroup style={{ marginTop: 10, display: "flex" }}>
          <Button
            style={{
              width: 100,
              height: 30,
              marginBottom: 20,
              borderColor: "#17721b",
            }}
            onClick={(e) => handleClickMenu(e)}
          >
            목록으로
          </Button>
        </ButtonGroup>
        <ButtonGroup
          style={{ marginTop: 10, marginRight: 30, display: "flex" }}
        >
          {editState ? (
            <></>
          ) : (
            <>
              <Button
                style={{
                  width: 100,
                  height: 30,
                  marginLeft: 20,
                  marginBottom: 20,
                  borderColor: "#2ad32c",
                }}
                onClick={(e) => handleClickEdit(e)}
              >
                수정하기
              </Button>
              <Button
                style={{
                  width: 100,
                  height: 30,
                  marginLeft: 20,
                  marginBottom: 20,
                  borderColor: "#ff0000",
                }}
                onClick={showModal}
              >
                {" "}
                삭제하기{" "}
              </Button>
            </>
          )}
        </ButtonGroup>
      </div>

      <Modal
        title="영양제정보 삭제"
        visible={isModalVisible}
        maskClosable={false}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>정말로 해당 영양제정보를 삭제하시겠습니까?</p>
      </Modal>

      <Row>
        <Col span={5}>
          <Row>
            <Col
              span={21}
              style={{
                textAlign: "center",
                border: "groove",
                height: 30,
                marginBottom: 15,
              }}
            >
              영양제 정보
            </Col>
          </Row>
          <Row>
            <Col
              span={10}
              style={{
                border: "double",
                paddingLeft: 3,
                backgroundColor: "#eaeaea",
                height: 30,
              }}
            >
              상태
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="상태"
                  disabled={true}
                  defaultValue={nutrientsData.status}
                  onChange={onSelectChange}
                >
                  {statusItems.map((items, idx) => {
                    return (
                      <Option
                        value={items.statusValue}
                        id={items.statusType}
                        key={`statusItems-${idx}`}
                      >
                        {items.statusText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.status === 0
                  ? "신청"
                  : nutrientsData.status === 1
                  ? "추가"
                  : "오류"}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              카테고리
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  style={{ height: 25, border: "none" }}
                  placeholder="수정할 값을 입력하세요."
                  id="category"
                  name="nutrients"
                  defaultValue={nutrientsData.category}
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.category}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              영양제이름
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  style={{ height: 25, border: "none" }}
                  placeholder="수정할 값을 입력하세요."
                  id="name"
                  name="nutrients"
                  defaultValue={nutrientsData.name}
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.name}
              </Col>
            )}
          </Row>

          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              영양제브랜드
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  style={{ height: 25, border: "none" }}
                  placeholder="수정할 값을 입력하세요."
                  id="brand_name"
                  name="nutrients"
                  defaultValue={nutrientsData.brand_name}
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.brand_name}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              브랜드타입
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="영양제브랜드타입"
                  defaultValue={nutrientsData.brand_type}
                  onChange={onSelectChange}
                >
                  {typeItems.map((items, idx) => {
                    return (
                      <Option
                        value={items.typeValue}
                        id={items.typeType}
                        key={`brand_type-${idx}`}
                      >
                        {items.typeText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.brand_type}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                fontSize: "smaller",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              헬씨팀 인증여부
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="인증여부"
                  disabled={true}
                  defaultValue={nutrientsData.is_certify}
                  onChange={onSelectChange}
                >
                  {certifyItems.map((items, idx) => {
                    return (
                      <Option
                        value={items.certifyValue}
                        id={items.certifyType}
                        key={`is_certify-${idx}`}
                      >
                        {items.certifyText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.is_certify === true ? "인증" : "미인증"}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              분량
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  type="number"
                  style={{ height: 25, border: "none" }}
                  placeholder="수정할 값을 입력하세요."
                  id="nutrition_facts"
                  name="nutrients"
                  defaultValue={nutrientsData.nutrition_facts}
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.nutrition_facts}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              분량 단위
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="단위선택"
                  defaultValue={nutrientsData.nutrition_facts_unit}
                  onChange={onSelectChange}
                >
                  {nutritionFactsUnitItems.map((items) => {
                    return (
                      <Option
                        value={items.nutritionUnitValue}
                        id={items.nutritionUnitType}
                      >
                        {items.nutritionUnitText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.nutrition_facts_unit}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              칼로리(kcal)
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  type="number"
                  style={{ height: 25, border: "none" }}
                  placeholder="입력대기중..."
                  id="energy"
                  name="nutrients"
                  defaultValue={nutrientsData.energy}
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.energy}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
              }}
            >
              인분 수
            </Col>
            {editState ? (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30 }}
              >
                <Input
                  type="number"
                  style={{ height: 25, border: "none" }}
                  placeholder="입력대기중..."
                  id="for_person"
                  name="nutrients"
                  defaultValue={nutrientsData.for_person}
                  allowClear
                  onChange={onChange}
                />
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.for_person}
              </Col>
            )}
          </Row>
          <Row style={{ marginTop: 5 }}>
            <Col
              span={10}
              style={{
                border: "double",
                backgroundColor: "#eaeaea",
                paddingLeft: 3,
                height: 30,
                fontSize: "small",
              }}
            >
              인분 단위
            </Col>
            {editState ? (
              <Col span={10} offset={1} style={{ height: 30 }}>
                <Select
                  style={{ width: 113 }}
                  placeholder="단위선택"
                  defaultValue={nutrientsData.for_person_unit}
                  onChange={onSelectChange}
                >
                  {forPersonUnitItems.map((items) => {
                    return (
                      <Option
                        value={items.personUnitValue}
                        id={items.personUnitType}
                      >
                        {items.personUnitText}
                      </Option>
                    );
                  })}
                </Select>
              </Col>
            ) : (
              <Col
                span={10}
                offset={1}
                style={{ border: "groove", height: 30, paddingLeft: 10 }}
              >
                {nutrientsData.for_person_unit}
              </Col>
            )}
          </Row>
        </Col>
        <Col span={19}>
          <Row>
            <Col
              span={23}
              style={{
                textAlign: "center",
                border: "groove",
                height: 30,
                marginLeft: 15,
                marginBottom: 15,
              }}
            >
              영양제 영양성분 정보
            </Col>
          </Row>
          <Row>
            <Col span={4}>
              <Row>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  식이섬유
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="total_dietary_fiber"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.total_dietary_fiber}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.total_dietary_fiber !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.total_dietary_fiber}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.total_dietary_fiber}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  칼슘
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="calcium"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.calcium}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.calcium !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.calcium + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.calcium}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  철
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="fe"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.fe}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.fe !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.fe + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.fe}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  마그네슘
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="magnesium"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.magnesium}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.magnesium !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.magnesium + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.magnesium}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  인(mg)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="perfect_virtue"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.perfect_virtue}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.perfect_virtue !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.perfect_virtue + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.perfect_virtue}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  칼륨(㎎)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="potassium"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.potassium}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.potassium !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.potassium + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.potassium}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  아연
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="zinc"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.zinc}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.zinc !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.zinc + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.zinc}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  구리
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="copper"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.copper}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.copper !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.copper + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.copper}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  망간
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="manganese"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.manganese}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.manganese !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.manganese + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.manganese}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  셀레늄
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="selenium"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.selenium}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.selenium !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.selenium + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.selenium}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  몰리브덴
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="molybdenum"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.molybdenum}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.molybdenum !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.molybdenum + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.molybdenum}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  요오드
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="iodine"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.iodine}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.iodine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.iodine + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.iodine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비타민 A
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_a"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.vitamin_a}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.vitamin_a !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.vitamin_a + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.vitamin_a}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  offset={1}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  베타카로틴
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="beta_carotene"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.beta_carotene}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.beta_carotene !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.beta_carotene}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.beta_carotene}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비타민 D
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_d"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.vitamin_d}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.vitamin_d !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.vitamin_d + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.vitamin_d}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비타민 E
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_e"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.vitamin_e}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.vitamin_e !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.vitamin_e + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.vitamin_e}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비타민 K
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_k"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.vitamin_k}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.vitamin_k !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.vitamin_k + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.vitamin_k}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  티아민(비타민 B1)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_b1"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.vitamin_b1}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.vitamin_b1 !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.vitamin_b1 + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.vitamin_b1}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  리보플라빈(비타민 B2)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_b2"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.vitamin_b2}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.vitamin_b2 !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.vitamin_b2 + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.vitamin_b2}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  나이아신(비타민 B3)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="niacin"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.niacin}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.niacin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.niacin + "(mg NE)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.niacin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  판토텐산(비타민 B5)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="pantothenic_acid"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.pantothenic_acid}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.pantothenic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.pantothenic_acid + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.pantothenic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  피리독신(비타민 B6)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="pyridoxine"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.pyridoxine}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.pyridoxine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.pyridoxine + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.pyridoxine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  비오틴(비타민
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="biotin"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.biotin}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.biotin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.biotin}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.biotin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  엽산(비타민 B9)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="folic_acid"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.folic_acid}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.folic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.folic_acid + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.folic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  코발라민(비타민 B12)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_b12"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.vitamin_b12}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.vitamin_b12 !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.vitamin_b12 + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.vitamin_b12}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  비타민 C
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="vitamin_c"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.vitamin_c}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.vitamin_c !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.vitamin_c + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.vitamin_c}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  오메가3
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="omega_3_fatty_acids"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.omega_3_fatty_acids}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.omega_3_fatty_acids !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.omega_3_fatty_acids + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.omega_3_fatty_acids}
                      </Col>
                    )}
                  </>
                )}
              </Row>

              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  크롬
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="chrome"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.chrome}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.chrome !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.chrome + "(㎍)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.chrome}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  보장균수(억cfu)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="guaranteed"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.guaranteed}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.guaranteed !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.guaranteed + "(억cfu)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.guaranteed}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  루테인
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="lutein"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.lutein}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.lutein !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.lutein + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.lutein}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  지아잔틴
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="zeaxanthin"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.zeaxanthin}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.zeaxanthin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.zeaxanthin + "(ug)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.zeaxanthin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  아스타잔틴
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="astaxanthin"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.astaxanthin}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.astaxanthin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.astaxanthin + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.astaxanthin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  실리마린
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="silymarin"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.silymarin}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.silymarin !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.silymarin + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.silymarin}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  CoQ10
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="coq10"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.coq10}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.coq10 !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.coq10 + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.coq10}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  진세노사이드
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="ginsenoside"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.ginsenoside}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.ginsenoside !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.ginsenoside + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.ginsenoside}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  플라보노이드
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="flavonoids"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.flavonoids}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.flavonoids !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.flavonoids + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.flavonoids}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  테아닌
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="theanine"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.theanine}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.theanine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.theanine + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.theanine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  콜라겐
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="collagen"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.collagen}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.collagen !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.collagen}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.collagen}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  L-라이신
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="l_lysine"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.l_lysine}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.l_lysine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.l_lysine}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.l_lysine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  L-아르기닌
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="l_arginine"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.l_arginine}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.l_arginine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.l_arginine}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.l_arginine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  이노시톨
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="inositol"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.inositol}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.inositol !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.inositol}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.inositol}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  옥타코사놀
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="octacosanol"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.octacosanol}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.octacosanol !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.octacosanol}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.octacosanol}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  HCA
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="hca"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.hca}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.hca !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.hca}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.hca}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  UDCA
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="udca"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.udca}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.udca !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.udca}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.udca}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  γ-오리자놀
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="γ_oryzanol"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.γ_oryzanol}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.γ_oryzanol !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.γ_oryzanol}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.γ_oryzanol}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  글루코사민
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="glucosamine"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.glucosamine}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.glucosamine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.glucosamine}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.glucosamine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  베타글루칸
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="betaglucan"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.betaglucan}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.betaglucan !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.betaglucan}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.betaglucan}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  맥주효모
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="brewersyeast"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.brewersyeast}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.brewersyeast !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.brewersyeast}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.brewersyeast}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  오로트산수화물
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="oroticacidhydrate"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.oroticacidhydrate}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.oroticacidhydrate !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.oroticacidhydrate}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.oroticacidhydrate}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  히알루론산
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="hyaluronic_acid"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.hyaluronic_acid}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.hyaluronic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.hyaluronic_acid + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.hyaluronic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  폴리감마글루탐산
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="glutamic_acid"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.glutamic_acid}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.glutamic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.glutamic_acid + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.glutamic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  MSM
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="msm"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.msm}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.msm !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.msm}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.msm}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  총안토시아노사이드
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="total_anthocyanosides"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.total_anthocyanosides}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.total_anthocyanosides !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.total_anthocyanosides}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.total_anthocyanosides}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  알파에스1카제인
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="alpha_s_1_casein"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.alpha_s_1_casein}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.alpha_s_1_casein !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.alpha_s_1_casein}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.alpha_s_1_casein}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    fontSize: 10,
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  열처리배양균체 수
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="cultured_cells"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.cultured_cells}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.cultured_cells !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.cultured_cells}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.cultured_cells}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  로사빈
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="rosabine"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.rosabine}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.rosabine !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.rosabine}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.rosabine}
                      </Col>
                    )}
                  </>
                )}
              </Row>
            </Col>
            <Col span={5}>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  로르산
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="lauric_acid"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.lauric_acid}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.lauric_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.lauric_acid}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.lauric_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: "smaller",
                  }}
                >
                  감마리놀렌산
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="linolenic_acid"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.linolenic_acid}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.linolenic_acid !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.linolenic_acid + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.linolenic_acid}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                    fontSize: 10,
                  }}
                >
                  녹차추출물(카테킨)
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="catechins"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.catechins}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.catechins !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.catechins + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.catechins}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  락추로스
                </Col>
                {editState ? (
                  <Col
                    span={9}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="수정할 값을 입력하세요."
                      id="lactulose"
                      name="nutrientsNutrition"
                      defaultValue={nutrientsNutrition.lactulose}
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <>
                    {nutrientsNutrition.lactulose !== 0 ? (
                      <Col
                        span={9}
                        offset={1}
                        style={{
                          border: "groove",
                          height: 30,
                          backgroundColor: "#fff7f7",
                        }}
                      >
                        {nutrientsNutrition.lactulose + "(mg)"}
                      </Col>
                    ) : (
                      <Col
                        span={9}
                        offset={1}
                        style={{ border: "groove", height: 30 }}
                      >
                        {nutrientsNutrition.lactulose}
                      </Col>
                    )}
                  </>
                )}
              </Row>
              <Row style={{ marginTop: 180 }}>
                <Col
                  span={21}
                  style={{
                    textAlign: "center",
                    border: "groove",
                    height: 30,
                    marginBottom: 5,
                  }}
                >
                  생성 및 수정 정보
                </Col>
              </Row>
              <Row>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  생성일
                </Col>
                {editState ? (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{
                        height: 25,
                        border: "none",
                        fontSize: "smaller",
                        width: 110,
                      }}
                      placeholder="입력대기중..."
                      id="created_at"
                      name="nutrients"
                      defaultValue={
                        nutrientsData.created_at === null
                          ? "-"
                          : moment(nutrientsData.created_at).format(
                              "YYYY-MM-DD",
                            )
                      }
                      bordered={false}
                      disabled
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <Col
                    span={10}
                    offset={1}
                    style={{
                      border: "groove",
                      height: 30,
                      fontSize: "smaller",
                    }}
                  >
                    {nutrientsData.created_at === null
                      ? "-"
                      : moment(nutrientsData.created_at).format("YYYY-MM-DD")}
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  생성자
                </Col>
                {editState ? (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="입력대기중..."
                      id="created_by_name"
                      name="nutrients"
                      defaultValue={
                        nutrientsData.created_by_name === 0
                          ? "Admin"
                          : nutrientsData.created_by_name
                      }
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    {nutrientsData.created_by_name === 0
                      ? "Admin"
                      : nutrientsData.created_by_name}
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  마지막수정일
                </Col>
                {editState ? (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{
                        height: 25,
                        border: "none",
                        fontSize: "smaller",
                        width: 110,
                      }}
                      placeholder="입력대기중..."
                      id="updated_at"
                      name="nutrients"
                      defaultValue={
                        nutrientsData.updated_at === null
                          ? "-"
                          : moment(nutrientsData.updated_at).format(
                              "YYYY-MM-DD",
                            )
                      }
                      bordered={false}
                      disabled
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <Col
                    span={10}
                    offset={1}
                    style={{
                      border: "groove",
                      height: 30,
                      fontSize: "smaller",
                    }}
                  >
                    {nutrientsData.updated_at === null
                      ? "-"
                      : moment(nutrientsData.updated_at).format("YYYY-MM-DD")}
                  </Col>
                )}
              </Row>
              <Row style={{ marginTop: 5 }}>
                <Col
                  span={10}
                  style={{
                    border: "double",
                    backgroundColor: "#eaeaea",
                    paddingLeft: 3,
                    height: 30,
                  }}
                >
                  수정자
                </Col>
                {editState ? (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    <Input
                      style={{ height: 25, border: "none" }}
                      placeholder="입력대기중..."
                      id="updated_by_name"
                      name="nutrients"
                      defaultValue={
                        nutrientsData.updated_by_name === 0
                          ? "Admin"
                          : nutrientsData.updated_by_name
                      }
                      allowClear
                      onChange={onChange}
                    />
                  </Col>
                ) : (
                  <Col
                    span={10}
                    offset={1}
                    style={{ border: "groove", height: 30 }}
                  >
                    {nutrientsData.updated_by_name === 0
                      ? "Admin"
                      : nutrientsData.updated_by_name}
                  </Col>
                )}
              </Row>
              <ButtonGroup
                style={{
                  marginTop: 10,
                  marginRight: 25,
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                {editState ? (
                  <>
                    <Button
                      style={{
                        width: 90,
                        height: 30,
                        backgroundColor: "red",
                        color: "white",
                      }}
                      onClick={(e) => handleClickCancel(e)}
                    >
                      취소하기
                    </Button>
                    <Button
                      style={{ width: 90, height: 30, marginLeft: 10 }}
                      type={"primary"}
                      onClick={(e) => handleClickComplete(e)}
                    >
                      저장하기
                    </Button>
                  </>
                ) : (
                  <></>
                )}
              </ButtonGroup>
            </Col>
          </Row>
        </Col>
      </Row>

      {nutrientsData.status === 0 ? (
        <Col span={24} style={{ marginTop: 30 }}>
          <Row>
            <h1> * 첨부사진 </h1>
          </Row>
          <Row>
            <Col span={6} offset={1} style={{}}>
              {fileList[0] === undefined ? (
                <div>첨부된 사진이 존재하지 없습니다.</div>
              ) : (
                <Image src={`${imageBaseUrl}${fileList[0].file_path}`} />
              )}
            </Col>
            <Col span={6} offset={2}>
              {fileList[1] === undefined ? (
                <></>
              ) : (
                <Image src={`${imageBaseUrl}${fileList[1].file_path}`} />
              )}
            </Col>
            <Col span={6} offset={2}>
              <Row>
                {fileList[2] === undefined ? (
                  <></>
                ) : (
                  <Image src={`${imageBaseUrl}${fileList[2].file_path}`} />
                )}
              </Row>
            </Col>
          </Row>
        </Col>
      ) : (
        console.log()
      )}
    </div>
  );
};

export default NutrientsCertifiedNutritionComponent;
